import React from 'react';
import { Text as RNText } from 'react-native';
import type { TextStyle, StyleProp } from 'react-native';

// Geçici marka logosu: Playfair Display'in (SIL OFL — açık lisans, ticari kullanım serbest)
// ampersand'ı. Asıl marka hazır olana dek yer-tutucu. Metin olarak render edilir, bu yüzden
// her ölçekte keskin ve tema-duyarlı (renk dışarıdan verilir). Font App.tsx'te yüklenir.
export default function Logo({
  size = 72,
  color = '#000',
  style,
}: {
  size?: number;
  color?: string;
  style?: StyleProp<TextStyle>;
}) {
  return (
    <RNText
      allowFontScaling={false}
      style={[
        { fontFamily: 'PlayfairDisplay_400Regular', fontSize: size, lineHeight: size * 1.12, color },
        style,
      ]}>
      &
    </RNText>
  );
}
